<template>
    <div class="animated fadeIn" v-if="isOrderLoaded()">
        <h2>Заявка № {{order.id}} </h2>
        <p>статус: {{order.status_text}} (#{{order.status_index}})</p>
        <form ref="orderForm" method="post" @submit.prevent>
            <b-row>
                <b-col md="6">

                    <b-card>
                        <div slot="header">
                            <strong>Организационное</strong>
                            <div class="card-header-actions">
                                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_places>
                                    <i class="icon-arrow-up"></i>
                                </b-link>
                            </div>
                        </div>

                        Создано: <span v-html="printDateTime(order.date_create_iso, false, true)" /><br/>

                    </b-card>


                    <b-card>
                        <div slot="header">
                            <strong>Заселение</strong>
                            <div class="card-header-actions">
                                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_places>
                                    <i class="icon-arrow-up"></i>
                                </b-link>
                            </div>
                        </div>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group>
                                    <label for="cities">Город</label>
                                    <multiselect
                                        v-model="selectedCity"
                                        :options="cities!==null?cities:[]"
                                        :multi="false"
                                        label="title"
                                        track-by="title"
                                        placeholder="Выберите город"
                                        @input="onChangeCity"
                                        @select="onChangeCity"
                                    ></multiselect>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="isHotelsLoaded()">
                            <b-col sm="12">
                                <b-form-group>
                                    <label for="hotels">Объект размещения</label>
                                    <multiselect
                                        v-model="selectedHotel"
                                        :options="hotels!==null?hotels:[]"
                                        :multi="false"
                                        label="title"
                                        track-by="title"
                                        placeholder="Выберите объект размещения"
                                        @input="onChangeHotel"
                                        @select="onChangeHotel"
                                    ></multiselect>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="isRoomsLoaded()">
                            <b-col sm="8">
                                <b-form-group>
                                    <label for="rooms">Номер</label>
                                    <b-form-select id="rooms"
                                                   :plain="true"
                                                   :options="rooms"
                                                   v-model="order.t_obj_rooms_id_correct"
                                                   value-field="id"
                                                   text-field="title"
                                                   @change="onChangeRoom"
                                    >
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="m_only_number">Бронировать</label><br>
                                    <b-button id='m_only_number' variant="outline-primary" :pressed.sync="order.m_only_number"> {{order.m_only_number ? 'весь номер целиком' : 'места по-одному'}}</b-button>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <p v-if="room && room.m_one_full" >в описании номера указано: бронируется весь номер</p>
                                <p v-if="room && !room.m_one_full" >в описании номера указано: бронировать места по-одному</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="3">
                                <b-form-group>
                                    <label for="check_in_date">Дата заезда</label>
                                    <v-date-picker id="check_in_date" v-model='order.date_begin_correct_iso'></v-date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group>
                                    <label for="check_out_date">Количество дней</label><br/>

                                    <b-button type="submit" size="sm" variant="primary" @click="setDays(2)"> 2 </b-button> &nbsp;
                                    <b-button type="submit" size="sm" variant="primary" @click="setDays(3)"> 3 </b-button> &nbsp;
                                    <b-button type="submit" size="sm" variant="primary" @click="setDays(10)"> 10 </b-button> &nbsp;
                                    <b-button type="submit" size="sm" variant="primary" @click="setDays(12)"> 12 </b-button> &nbsp;
                                    <b-button type="submit" size="sm" variant="primary" @click="setDays(14)"> 14 </b-button> &nbsp;
                                    <b-button type="submit" size="sm" variant="primary" @click="setDays(21)"> 21 </b-button>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <b-form-group>
                                    <label for="check_out_date">Дата выезда</label>
                                    <v-date-picker id="check_out_date" v-model='order.date_end_correct_iso'></v-date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group>
                                    <label for="count_grown_correct">Взрослых</label>
                                    <b-form-select id="count_grown_correct"
                                                   :plain="true"
                                                   :options="[0,1,2,3,4,5,6,7,8,9,10]"
                                                   v-model="order.count_grown_correct"
                                                   value-field="id"
                                                   text-field="title"
                                                   required
                                                   ref="count_grown_correct"
                                    >
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group>
                                    <label for="check_in_date">Детей</label>
                                    <b-form-select id="count_kids_correct"
                                                   :plain="true"
                                                   :options="[0,1,2,3,4,5,6,7,8,9,10]"
                                                   v-model="order.count_kids_correct"
                                                   value-field="id"
                                                   text-field="title"
                                                   required
                                                   ref="count_kids_correct"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>


                        </b-row>
                    </b-card>
                    <b-card>
                        <div slot="header">
                            <strong>Комментарии</strong>
                        </div>
                        <b-form-group
                            :state="validateScopedState('orderform', 'other_text_correct')"
                            label="Текст клиента"
                            :invalid-feedback="veeErrors.first('orderform.other_text_correct')">

                            <b-form-textarea type="text"
                                             v-model="order.other_text_correct"
                                             v-validate="{max:1000}"
                                             id="other_text_correct"
                                             name="other_text_correct"
                                             data-vv-as="'Текст клиента'"
                                             data-vv-scope="orderform"
                                             :state="validateScopedState('orderform', 'other_text_correct')"
                            ></b-form-textarea>
                        </b-form-group>
                        <b-form-group
                            :state="validateScopedState('orderform', 'comment_manager')"
                            label="Комментарий менеджера"
                            :invalid-feedback="veeErrors.first('orderform.comment_manager')">
                            <b-form-textarea type="text"
                                             v-model="order.comment_manager"
                                             v-validate="{max:10000}"
                                             id="comment_manager"
                                             name="comment_manager"
                                             data-vv-as="'Комментарий менеджера'"
                                             data-vv-scope="orderform"
                                             :invalid-feedback="veeErrors.first('orderform.comment_manager')">
                                ></b-form-textarea>
                        </b-form-group>
                    </b-card>

                    <b-card  no-body v-if="isTelecallsLoaded()">
                        <div slot="header">
                            <strong>Звонки</strong>
                            <div class="card-header-actions">
                                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_telecalls>
                                    <i class="icon-arrow-up"></i>
                                </b-link>
                            </div>
                        </div>
                        <b-collapse id="collapse_telecalls" visible v-model="show_telecalls">
                            <b-card-body>
                                <table class="table table-bordered table-sm table-hover table-striped " v-if="isTelecallsLoaded()">
                                    <tr>
                                        <th>#</th>
                                        <th>начало/завершение</th>
                                        <th>внешний номер</th>
                                        <th>менеджер</th>
                                        <th><i class="icon-social-youtube"></i></th>
                                    </tr>
                                    <tr v-for="t in telecalls">
                                        <td>#{{t.id}}</td>
                                        <td>
                                            <span class="nobr" v-html="printTimeDate(t.created_at)" v-if="!is(t.started_at) && !is(t.stopped_at)"></span>
                                            <span class="nobr" v-html="printTimeDate(t.started_at)" v-if="is(t.started_at)"></span>
                                            <span class="nobr" v-html="printTimeDate(t.stopped_at)" v-if="is(t.stopped_at)"></span>
                                        </td>
                                        <td>
                                            {{ CONSTANTS.TELEPHONY_TYPE_NAMES[t.type] }}<br>
                                            <a :href="'tel:'+t.phone_number">{{t.phone_number}}</a>
                                        </td>
                                        <td>
                                        <span v-if="is(t.user_id)">
                                            (#{{t.user_id}}) {{t.full_name}} <a :href="'tel:'+t.telephony_number">{{t.telephony_number}}</a>
                                        </span>
                                        </td>
                                        <td>
                                            <span v-if="is(t.record)"><a :href="t.record" target="_blank"><i class="icon-social-youtube"></i></a></span>
                                            <span v-if="!is(t.record)">
                                            {{ CONSTANTS.TELEPHONY_EVENTS_NAMES[t.event_type] }} {{ t.ring_duration }}
                                        </span>
                                        </td>
                                    </tr>
                                </table>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                </b-col>
                <b-col md="6">
                    <b-card>
                        <div slot="header">
                            <strong>Агент</strong>
                        </div>
                        Компания: (#{{ order.company_id }}) {{order.company_title}} <br>
                        Агент: (#{{ order.user_id }}) {{order.user_lastname}} {{order.user_firstname}} ({{order.user_login}})
                    </b-card>
                    <b-card>
                        <div slot="header">
                            <strong>Заказчик</strong>
                        </div>
                        <b-row>
                            <b-col sm="12" md="6">
                                <b-form-group
                                    :state="validateScopedState('orderform', 'name_correct')"
                                    label="* Имя"
                                    :invalid-feedback="veeErrors.first('orderform.name_correct')">

                                    <b-form-input type="text"
                                                  v-model="order.name_correct"
                                                  v-validate="{max:100,required:true}"
                                                  data-vv-scope="orderform"
                                                  id="name_correct"
                                                  name="name_correct"
                                                  data-vv-as="'Имя'"
                                                  :state="validateScopedState('orderform', 'name_correct')"
                                                  z                                    ></b-form-input>

                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="6">
                                <b-form-group
                                    :state="validateScopedState('orderform', 'patro_correct')"
                                    label="Отчество"
                                    :invalid-feedback="veeErrors.first('orderform.patro_correct')"
                                >
                                    <b-form-input type="text"
                                                  v-model="order.patro_correct"
                                                  v-validate="{max:100}"
                                                  id="patro_correct"
                                                  name="patro_correct"
                                                  data-vv-scope="orderform"
                                                  data-vv-as="'Отчество'"
                                                  :state="validateScopedState('orderform', 'patro_correct')"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="6">
                                <b-form-group
                                    :state="validateScopedState('orderform', 'surname_correct')"
                                    label="Фамилия"
                                    :invalid-feedback="veeErrors.first('orderform.surname_correct')"
                                >
                                    <b-form-input type="text"
                                                  v-model="order.surname_correct"
                                                  v-validate="{max:100}"
                                                  id="surname_correct"
                                                  data-vv-scope="orderform"
                                                  name="surname_correct"
                                                  data-vv-as="'Фамилия'"
                                                  :state="validateScopedState('orderform', 'surname_correct')"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="6">
                                <b-form-group
                                    :state="validateScopedState('orderform', 'city_correct')"
                                    label="Город проживания"
                                    :invalid-feedback="veeErrors.first('orderform.city_correct')"
                                >
                                    <city-input v-model="order.city_correct"
                                                v-validate="{max:100}"
                                                data-vv-scope="orderform"
                                                name="city_correct"
                                                data-vv-as="'Город проживания'"
                                                :state="validateScopedState('orderform', 'city_correct')"
                                                vvalidate="{max:100}"
                                                datavvscope="orderform"
                                                datavvas="'Город проживания'"
                                    ></city-input>

                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card>
                        <div slot="header">
                            <strong>Контакты</strong>
                        </div>

                        <b-form-group
                            :state="validateScopedState('orderform', 'email_correct')"
                            label="E-mail"
                            :invalid-feedback="veeErrors.first('orderform.email_correct')"
                        >
                            <b-form-input type="text" id="email_correct"
                                          v-model="order.email_correct"
                                          v-validate="{max:100,email:true}"
                                          data-vv-scope="orderform"
                                          name="email_correct"
                                          data-vv-as="'Контактный e-mail'"
                                          :state="validateScopedState('orderform', 'email_correct')"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group>
                            <label>телефоны</label>
                        </b-form-group>
                        <b-row v-if="isTelenumsLoaded()"  v-for="(telenum, i) in telenums" :key="telenum.id">
                            <b-col xs="6">
                                <b-form-group
                                    :state="validateScopedState('orderform', 'telenum_number'+i)"
                                    :invalid-feedback="veeErrors.first('orderform.telenum_number'+i)"
                                >
                                    <span  class="flex-form__item-inline-telenum" v-if="telenum.id"><a :href="'tel:'+telenum.number">{{ telenum.number }}</a></span>
                                    <b-form-input v-if="!telenum.id"
                                                  type="text" id="telenum_number"
                                                  v-model="telenum.number"
                                                  v-validate="{phone:true}"
                                                  data-vv-scope="orderform"
                                                  :name="'telenum_number'+i"
                                                  data-vv-as="'Номер телефона'"
                                                  :state="validateScopedState('orderform', 'telenum_number'+i)"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col xs="6">
                                <b-form-group
                                    :state="validateScopedState('orderform', 'telenum_info'+i)"
                                    :invalid-feedback="veeErrors.first('orderform.telenum_info'+i)"
                                >
                                    <b-form-input type="text" id="telenum_info"
                                                  v-model="telenum.info"
                                                  data-vv-scope="orderform"
                                                  v-validate="{max:200}"
                                                  name="telenum_info"
                                                  data-vv-as="'Комментарий к номеру'"
                                                  :state="validateScopedState('orderform', 'telenum_info'+i)"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-button id='m_only_number' variant="success" @click="onAddPhone">  <i class="fa fa-plus"></i> Добавить телефонный номер </b-button>

                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-card>
                        <b-button variant="secondary" @click="onClose()" >  <i class="fa fa-close" ></i> Вернуться в список </b-button>  &nbsp;
                        <b-button variant="success" @click="onSave()" >  <i class="fa fa-save" ></i> Сохранить </b-button>  &nbsp;
                        <b-button variant="success" @click="onApply()" >  <i class="fa fa-save" ></i> Применить </b-button> &nbsp;
                        <template v-if="canCancelOrder(order)">
                            <b-button variant="danger" @click="onArchive()" >  <i class="fa fa-times" ></i> Анулировать </b-button>  &nbsp;
                        </template>
                        <template v-if="canChuserOrder(order)">
                            <b-button variant="warning" @click="onChuser()" >  <i class="fa fa-user" ></i> Передать </b-button>  &nbsp;
                        </template>
                        <template v-if="canPostponeOrder(order)">
                            <b-button variant="warning" @click="onWait()" >  <i class="fa fa-clock-o" ></i> В ожидание </b-button>  &nbsp;
                        </template>
                        <template v-if="canRevertOrder(order)">
                            <b-button variant="primary" @click="onRevert()" >  <i class="fa fa-wake" ></i> Вернуть в работу </b-button>  &nbsp;
                        </template>
                        <template v-if="canCreateVoucherFromOrder(order)">
                            <b-button variant="success" @click="onCreateVoucher()" >  <i class="fa fa-arrow-right" ></i> Оформить путевку </b-button>  &nbsp;
                        </template>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    {{ order }}
                </b-col>
            </b-row>
        </form>

        <b-modal title="Анулирование заявки" class="modal-danger" centered  v-model="archiveeConfirm" ok-variant="danger" @ok.prevent="handleSubmitArchiveConfirm">
            <form  ref="archiveeConfirmForm" @submit.prevent="handleSubmitArchiveConfirm">
                <b-form-group
                    :state="validateScopedState('cancel', 'cancelReason')"
                    label="Резолюция"
                    label-for="name-input"
                    :invalid-feedback="veeErrors.first('cancel.cancelReason')"
                >
                    <b-form-select id="cancelReason"
                                   :plain="true"
                                   :options="orderCancelReasons"
                                   v-model="cancelReason"
                                   value-field="id"
                                   text-field="text"
                                   required
                                   v-validate="{required:true}"
                                   data-vv-as="Резолюция"
                                   data-vv-name="cancelReason"
                                   data-vv-scope="cancel"
                                   ref="cancelReason"
                                   :state="validateScopedState('cancel', 'cancelReason')"
                    >
                    </b-form-select>
                </b-form-group>
                <b-form-group
                    :state="validateScopedState('cancel', 'cancelComment')"
                    label="Комментарий/подробности"
                    label-for="name-input"
                    :invalid-feedback="veeErrors.first('cancel.cancelComment')"
                >
                    <b-form-textarea
                        id="cancelComment"
                        v-model="cancelComment"
                        data-vv-as="Причина"
                        data-vv-name="cancelComment"
                        data-vv-scope="cancel"
                        required
                        v-validate="{required:true, max:200}"
                        ref="cancelComment"
                        :state="validateScopedState('cancel', 'cancelComment')"
                    ></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }"></template>
        </b-modal>

        <b-modal title="Отправка заявки в сон" class="modal-warning" centered  v-model="waitConfirm" variant="warning" ok-variant="warning" @ok.prevent="handleSubmitWaitConfirm">
            <form ref="waitConfirmForm" @submit.prevent="handleSubmitWaitConfirm">
                <b-form-group
                    :state="validateScopedState('wait', 'waitDate')"
                    label="Укажите дату до которой заявка отправляется в сон"
                    label-for="name-input"
                    :invalid-feedback="veeErrors.first('wait.waitDate')"
                    required
                    v-validate="{required:true}"
                >
                    <v-date-picker id="waitDate"
                                   data-vv-scope="wait"
                                   v-model='waitDate'
                                   required
                                   v-validate="{required:true}"
                                   data-vv-as="Дата возврата"
                                   data-vv-name="waitDate"
                                   :ref="'waitDate'"
                                   :state="validateScopedState('wait', 'waitDate')"
                    ></v-date-picker>
                </b-form-group>

                <b-form-group
                    :state="validateScopedState('wait', 'waitComment')"
                    label="Укажите причину отправки заявки в сон"
                    label-for="waitComment"
                    :invalid-feedback="veeErrors.first('wait.waitComment')"
                >
                    <b-form-textarea
                        id="waitComment"
                        v-model="waitComment"
                        data-vv-as="Причина"
                        data-vv-name="waitComment"
                        :state="validateScopedState('wait', 'waitComment')"
                        required
                        v-validate="{required:true, max:200}"
                        data-vv-scope="wait"
                        ref="waitComment"
                    ></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }"></template>
        </b-modal>

        <b-modal title="Передача заявки другому агенту" class="modal-warning" centered  v-model="chuserConfirm" ok-variant="primary" @ok.prevent="handleSubmitChuserConfirm">
            <form ref="chuserConfirmForm" @submit.prevent="handleSubmitChuserConfirm">
                <b-form-group
                    :state="validateScopedState('chuser', 'chuserUser')"
                    label="Укажите пользователя, которому будет передана заявка"
                    label-for="name-input"
                    invalid-feedback="Пользователь должен быть указан"
                    required
                    v-validate="{required:true}"
                >
                    <b-form-select id="chuserUser"
                                   :plain="true"
                                   :options="getUsers"
                                   v-model="chuserUser"
                                   value-field="id"
                                   text-field="full_name"
                                   required
                                   v-validate="{required:true}"
                                   data-vv-as="chuserUser"
                                   data-vv-name="chuserUser"
                                   data-vv-scope="chuser"
                                   ref="chuserUser"
                                   :state="validateScopedState('chuser', 'chuserUser')"
                    >
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    :state="validateScopedState('chuser', 'chuserComment')"
                    label="Укажите причину передачи другому пользователю"
                    :invalid-feedback="veeErrors.first('chuser.chuserComment')">
                    <b-form-textarea
                        id="chuserComment"
                        v-model="chuserComment"
                        data-vv-as="chuserComment"
                        data-vv-name="chuserComment"
                        :state="validateScopedState('chuser', 'chuserComment')"
                        required
                        v-validate="{required:true, max:200}"
                        data-vv-scope="chuser"
                        ref="chuserComment"
                    ></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }"></template>
        </b-modal>

    </div>
</template>

<script>
    import {CONSTANTS} from '@/constants';
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_room } from '@/functions_room.js';
    import { functions_order } from '@/functions_order.js';
    import { functions_hotel } from '@/functions/hotel.js';
    import { functions_city } from '@/functions_city.js';

    import { Switch as cSwitch } from '@coreui/vue'
    import CityInput from '@/components/CityInput'

    const today = new Date()

    export default {
        name: 'NsbAgentOrder',
        mixins: [functions, functions_loaders, functions_order, functions_hotel, functions_city, functions_room],
        components: {
            cSwitch,
            CityInput
        },
        data: function () {
            return {
                order_id: null,
                selectedHotel:null,
                selectedCity:null,
                selectedCity:null,
                dstart:null,
                dend:null,
                archiveeConfirm: false,
                waitConfirm: false,
                chuserConfirm: false,

                waitComment:null,
                waitDate:null,
                cancelReason:null,
                cancelComment:null,
                orderCancelReasons: [
                    {id:0, text:''},
                    {id:1, text:'Оформлена путевка'},
                    {id:2, text:'Дубликат'},
                    {id:3, text:'Отказ клиента - без указания причин'},
                    {id:4, text:'Некорректные данные'},
                    {id:5, text:'Нет мест'},
                    {id:6, text:'Спам'},
                    {id:7, text:'Есть уже льготная путевка'},
                    {id:8, text:'Есть бронь в объекте отдыха'},
                    {id:9, text:'Отказ по болезни'},
                    {id:10, text:'Отказ передумал ехать'},
                    {id:11, text:'Отказ забронировал в другом агентстве'},
                    {id:12, text:'Отказ забронировал напрямую в объекте'},
                ],

                chuserUser:null,
                chuserComment:null,

            }
        },
        methods: {
            onChangeCity: function () {
                if (this.selectedCity && (this.selectedCity !== null)) {
                    this.console_log(this.selectedCity.id);
                    this.order.t_city_id_correct = this.selectedCity.id;
                    this.order.t_obj_items_id_correct = 0;
                    this.order.t_obj_rooms_id_correct = 0;
                    this.selectedHotel = null;
                    this.order.t_obj_tariff_id = 0;
                    this.resetHotel();
                    this.resetRoom();
                    this.resetHotels().loadCityHotels(this.order.t_city_id_correct);
                    this.resetRooms();
                    //this.resetPrices();
                    //this.resetPrograms();
                    //this.resetPersons(true);
                }
            },
            onChangeHotel: function () {
                if (this.selectedHotel && (this.selectedHotel !== null)) {
                    this.console_log(this.selectedHotel.id);
                    this.order.t_obj_items_id_correct = this.selectedHotel.id;
                    this.order.t_obj_rooms_id_correct = 0;
                    this.order.t_obj_tariff_id = 0;
                    //this.resetPersons(true);
                    this.resetHotel().loadHotel(this.order.t_obj_items_id_correct);
                    this.resetRooms().loadRooms(this.order.t_obj_items_id_correct);
                    //this.resetPrograms().loadPrograms(this.order.t_obj_items_id_correct);
                    //this.resetPrices();
                    //this.resetQuotas();
                    //this.loadDiscounts(this.order.t_obj_items_id_correct);
                }
            },
            onChangeRoom: function () {
                this.resetPrices();
                //this.resetPersons(false);
                this.resetRoom().loadRoom(this.order.t_obj_rooms_id_correct);
            },
            setSelectedCity() {
                //this.console_log('setSelectedCity');
                //this.console_log('t_city_id_correct=', this.order.t_city_id_correct);
                this.selectedCity = null;
                if (this.order && this.isCitiesLoaded()) {
                    //this.console_log('++');
                    for (let i = 0; i < this.cities.length; i++) {
                        if (this.order.t_city_id_correct === this.cities[i].id) {
                            this.selectedCity = this.cities[i];
                            this.console_log(this.selectedCity);
                            return;
                        }
                    }
                    //this.console_log('+++');
                }

            },
            setSelectedHotel() {
                this.console_log('setSelectedHotel');
                this.console_log('t_obj_items_id_correct=', this.order.t_obj_items_id_correct);
                this.selectedHotel = null;
                if (this.order && this.isHotelsLoaded()) {
                    this.console_log('++');
                    for (let i = 0; i < this.hotels.length; i++) {
                        if (this.order.t_obj_items_id_correct === this.hotels[i].id) {
                            this.selectedHotel = this.hotels[i];
                            this.console_log(this.selectedHotel);
                            return;
                        }
                    }
                    this.console_log('+++');
                }
            },
            setDays:function(days) {
                let d = new Date(this.order.date_begin_correct_iso);
                d.setDate(d.getDate()+days);
                this.order.date_end_correct_iso = d;
            },
            onClose: function () {
                this.$router.back();
                this.$router.push({ path: this.ordersPage})
            },
            onSave :function () {
                this.$validator.validateAll('orderform').then((result) => {
                        this.console_log(result)
                        if (!result) return false;
                        this.archiveeConfirm = false;
                        this.saveOrder(function (self) {
                            self.$router.back();
                            self.$router.push({ path: self.ordersPage});
                        }, this);
                    }, (error) => {
                        this.console_log('error')
                    }
                );
            },
            onApply :function () {
                this.$validator.validateAll('orderform').then((result) => {
                        if (!result) return false;
                        this.archiveeConfirm = false;
                        this.saveOrder();
                    }, (error) => {
                        this.console_log('error')
                    }
                );
            },

            onArchive: function () {
                this.archiveeConfirm = true;
            },

            onWait: function () {
                this.waitConfirm = true;
            },

            onRevert: function () {
                this.revertOrder();
            },

            onChuser: function () {
                this.chuserConfirm = true;
            },

            handleSubmitWaitConfirm: function () {
                this.console_log('handleSubmitWaitConfirm -1')
                this.$validator.validateAll('wait').then((result) => {
                    if (!result) return false;
                    this.waitConfirm = false;
                    this.waitOrder(this.waitDate, this.waitComment, function (self) {
                        self.$router.back();
                        self.$router.push({ path: self.ordersPage})
                    }, this);
                    return true;
                });
            },

            handleSubmitArchiveConfirm: function () {
                this.$validator.validateAll('cancel').then((result) => {
                    if (!result) return false;
                    this.archiveeConfirm = false;
                    this.cancelOrder(this.cancelReason, this.cancelComment, function (self) {
                        self.$router.back();
                        self.$router.push({ path: self.ordersPage});
                    }, this);
                });
            },

            handleSubmitChuserConfirm: function () {
                this.$validator.validateAll('chuser').then((result) => {
                    if (!result) return false;
                    this.chuserConfirm = false;
                    this.chuserOrder(this.chuserUser, this.chuserComment, function (self) {
                        self.$router.back();
                        self.$router.push({path: self.ordersPage});
                    }, this);
                });
            },

            onCreateVoucher: function () {
                this.crvOrder(function (self) {
                    self.$router.back();
                    self.$router.push({path: self.ordersPage});
                }, this);
            },

            onAddPhone: function () {
                this.telenums.push({number:'', info:'', new:1});
            },
        },
        computed: {
            getUsers: function () {
                return this.$store.state.user.company.users;
            }
        },
        mounted: function(){
            this.order_id = this.$router.currentRoute.params.order_id;
            this.loadCities();
            this.resetOrder().loadOrder(this.order_id);
        },
        watch: {
            cities_loaded : function() {
                this.console_log('cities_loaded');
                if (this.isOrderLoaded())
                    this.setSelectedCity();
            },
            hotels_loaded : function() {
                this.console_log('hotels_loaded');
                if (this.isOrderLoaded())
                    this.setSelectedHotel();
            },
            order : function() {
                this.console_log('order changed');
                this.order.m_only_number = !!this.order.m_only_number;
                this.setSelectedCity();
                if (this.order.t_city_id_correct) {
                    this.resetHotels().loadCityHotels(this.order.t_city_id_correct);
                    if(this.order.t_obj_items_id_correct) {
                        this.resetRooms().loadRooms(this.order.t_obj_items_id_correct);
                    }
                }
                this.setSelectedHotel();

                if (!this.order.date_begin_correct_iso || this.order.date_begin_correct_iso==null)
                {
                    this.order.date_begin_correct_iso = new Date();
                    this.order.date_begin_correct_iso.setDate(this.order.date_begin_correct_iso.getDate()+1);
                    this.order.date_end_correct_iso = new Date();
                    this.order.date_end_correct_iso.setDate(this.order.date_end_correct_iso.getDate()+15);
                }
                else {
                    this.order.date_begin_correct_iso = new Date(this.order.date_begin_correct_iso);
                    this.order.date_end_correct_iso = new Date(this.order.date_end_correct_iso);
                }

                this.resetTelenums().loadTelenumsForOrder(this.order_id);
                this.resetTelecalls().loadTelecallsForOrder(this.order_id);
            }
        },
    };
</script>

<style lang="scss"></style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
